import { render, staticRenderFns } from "./TrocarSenha.vue?vue&type=template&id=3cd13463&"
import script from "./TrocarSenha.vue?vue&type=script&lang=js&"
export * from "./TrocarSenha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports